import { Component, OnInit } from '@angular/core';
import { faRoute } from '@fortawesome/free-solid-svg-icons'

@Component({
  selector: 'app-private',
  templateUrl: './private.page.html',
  styleUrls: ['./private.page.scss'],
})
export class PrivatePage implements OnInit {
  faroute = faRoute;
  constructor() { }

  ngOnInit() {
  }

}
